/* NITRECK Dawn-Warenkorb: Lieferprognose und manuelle Produktempfehlungen. */
(() => {
  'use strict';
  if (window.NitreckCartDrawer) return;

  const dayKey = date => date.toISOString().slice(0, 10);
  const holidaysByYear = new Map();

  function easterSunday(year) {
    const a = year % 19;
    const b = Math.floor(year / 100);
    const c = year % 100;
    const d = Math.floor(b / 4);
    const e = b % 4;
    const f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4);
    const k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31);
    const day = (h + l - 7 * m + 114) % 31 + 1;
    return new Date(Date.UTC(year, month - 1, day, 12));
  }

  function holidays(year) {
    if (holidaysByYear.has(year)) return holidaysByYear.get(year);
    // Bundesweite Feiertage; keine regionalen Feiertage des Empfängerorts.
    const dates = new Set(
      ['01-01', '05-01', '10-03', '12-25', '12-26'].map(d => `${year}-${d}`)
    );
    for (const offset of [-2, 1, 39, 50]) {
      const date = easterSunday(year);
      date.setUTCDate(date.getUTCDate() + offset);
      dates.add(dayKey(date));
    }
    holidaysByYear.set(year, dates);
    return dates;
  }

  function berlinCalendarDate(now = new Date()) {
    const parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Berlin',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).formatToParts(now);
    const part = type => Number(parts.find(p => p.type === type).value);
    // UTC-Mittag dient als reines Kalenderdatum, unabhängig von Sommerzeit.
    return new Date(Date.UTC(part('year'), part('month') - 1, part('day'), 12));
  }

  function addBusinessDays(date, amount) {
    const result = new Date(date);
    let count = 0;
    while (count < amount) {
      result.setUTCDate(result.getUTCDate() + 1);
      const weekday = result.getUTCDay();
      if (
        weekday !== 0 &&
        weekday !== 6 &&
        !holidays(result.getUTCFullYear()).has(dayKey(result))
      ) {
        count++;
      }
    }
    return result;
  }

  function deliveryRange(now = new Date()) {
  const dispatchWeekdays = [1, 3, 5]; // Montag, Mittwoch, Freitag
  const cutoffHour = 12;            // Deutsche Ortszeit
  const minTransitDays = 1;
  const maxTransitDays = 3;         // Laufzeit inklusive Puffertag

  const today = berlinCalendarDate(now);

  const berlinHour = Number(
    new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Berlin',
      hour: '2-digit',
      hourCycle: 'h23'
    }).format(now)
  );

  const dispatch = new Date(today);

  if (berlinHour >= cutoffHour) {
    dispatch.setUTCDate(dispatch.getUTCDate() + 1);
  }

  while (
    !dispatchWeekdays.includes(dispatch.getUTCDay()) ||
    holidays(dispatch.getUTCFullYear()).has(dayKey(dispatch))
  ) {
    dispatch.setUTCDate(dispatch.getUTCDate() + 1);
  }

  function addDeliveryDays(date, amount) {
    const result = new Date(date);
    let count = 0;

    while (count < amount) {
      result.setUTCDate(result.getUTCDate() + 1);

      if (
        result.getUTCDay() !== 0 &&
        !holidays(result.getUTCFullYear()).has(dayKey(result))
      ) {
        count++;
      }
    }

    return result;
  }

  const start = addDeliveryDays(dispatch, minTransitDays);
  const end = addDeliveryDays(dispatch, maxTransitDays);

  const withYear =
    start.getUTCFullYear() !== today.getUTCFullYear() ||
    end.getUTCFullYear() !== today.getUTCFullYear();

  const formatter = new Intl.DateTimeFormat('de-DE', {
    timeZone: 'UTC',
    weekday: 'short',
    day: '2-digit',
    month: '2-digit',
    ...(withYear ? { year: 'numeric' } : {})
  });

  return {
    dispatch: dayKey(dispatch),
    start: dayKey(start),
    end: dayKey(end),
    text: `${formatter.format(start)} – ${formatter.format(end)}`
  };
}

  window.NitreckCartDrawer = Object.freeze({ deliveryRange });

  class NitreckDeliveryWindow extends HTMLElement {
    connectedCallback() {
      this.refresh = () => {
        if (!this.isConnected) return;
        const min = Number(this.dataset.minDays) || 2;
        const max = Math.max(min, Number(this.dataset.maxDays) || 4);
        const target = this.querySelector('[data-nt-date]');
        if (target) {
          target.textContent = deliveryRange(new Date(), min, max).text;
        }
      };
      this.refresh();
      // Auch beim Zurückkehren zu einem über Nacht geöffneten Tab aktualisieren.
      document.addEventListener('visibilitychange', this.refresh);
      this.timer = window.setInterval(this.refresh, 60000);
    }

    disconnectedCallback() {
      document.removeEventListener('visibilitychange', this.refresh);
      window.clearInterval(this.timer);
    }
  }

  class NitreckCartUpsells extends HTMLElement {
    connectedCallback() {
      this.onClick = event => {
        const button = event.target.closest('[data-nt-add]');
        if (button && this.contains(button)) this.add(button);
      };
      this.onChange = event => {
        const select = event.target.closest('[data-nt-variant]');
        if (!select) return;
        // Dawn darf diese Auswahl nicht als Änderung einer Warenkorbmenge lesen.
        event.stopPropagation();
        const card = select.closest('[data-nt-card]');
        const option = select.selectedOptions[0];
        card.querySelector('[data-nt-price]').textContent = option.dataset.price;
        const unit = card.querySelector('[data-nt-unit]');
        unit.textContent = option.dataset.unit || '';
        unit.hidden = !option.dataset.unit;
      };
      this.addEventListener('click', this.onClick);
      this.addEventListener('change', this.onChange);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('change', this.onChange);
    }

    async add(button) {
      if (this.busy) return;
      if (button.dataset.ntReload) {
        window.location.reload();
        return;
      }

      const drawer = this.closest('cart-drawer');
      const errorBox = this.querySelector('[data-nt-error]');
      if (!drawer) return;
      if (drawer.querySelector('.cart__items--disabled, .cart-item--disabled')) {
        return;
      }

      this.busy = true;
      this.setAttribute('aria-busy', 'true');
      errorBox.hidden = true;

      const oldLabel = button.textContent;
      const card = button.closest('[data-nt-card]');
      const option = card.querySelector('[data-nt-variant]')?.selectedOptions[0];
      const variantId = Number(option?.value || button.dataset.variantId);
      const quantity = Math.max(
        1,
        Number(option?.dataset.quantity || button.dataset.quantity) || 1
      );
      const productTitle = button.dataset.productTitle;

      // Paralleländerungen während der Anfrage verhindern, Schließen bleibt möglich.
      const controls = [
        ...drawer.querySelectorAll('button, input, select')
      ].filter(
        el => !el.disabled && !el.classList.contains('drawer__close')
      );
      controls.forEach(el => {
        el.disabled = true;
      });
      button.textContent = 'Wird hinzugefügt …';

      let confirmedAdded = false;
      let explicitRejection = false;
      let requireReload = false;
      const controller = new AbortController();
      const timeout = window.setTimeout(() => controller.abort(), 20000);

      try {
        const root = window.Shopify?.routes?.root || '/';
        const sections =
          typeof drawer.getSectionsToRender === 'function'
            ? drawer.getSectionsToRender().map(section => section.id)
            : ['cart-drawer', 'cart-icon-bubble'];

        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          signal: controller.signal,
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items: [{ id: variantId, quantity }],
            sections,
            sections_url: window.location.pathname
          })
        });

        const data = await response.json();
        if (!response.ok || Number(data.status) >= 400) {
          explicitRejection = response.status >= 400 && response.status < 500 && response.status !== 422;
          throw new Error(
            typeof data.description === 'string'
              ? data.description
              : 'Der Artikel konnte nicht hinzugefügt werden.'
          );
        }

        confirmedAdded = true;

        // Ein erfolgreicher POST kann bei einem Renderfehler null-Sections liefern.
        // Nur die Darstellung erneut abrufen, niemals erneut den Artikel hinzufügen.
        if (sections.some(id => typeof data.sections?.[id] !== 'string')) {
          const url = new URL(window.location.href);
          url.searchParams.set('sections', sections.join(','));
          const rendered = await fetch(url, {
            signal: controller.signal,
            headers: { Accept: 'application/json' }
          });
          if (!rendered.ok) {
            throw new Error('Der Warenkorb konnte nicht aktualisiert werden.');
          }
          data.sections = await rendered.json();
        }

        if (
          sections.some(id => typeof data.sections?.[id] !== 'string') ||
          typeof drawer.renderContents !== 'function'
        ) {
          throw new Error('Der Warenkorb konnte nicht aktualisiert werden.');
        }

        drawer.classList.remove('is-empty');
        drawer.renderContents(data);

        if (
          typeof publish === 'function' &&
          typeof PUB_SUB_EVENTS !== 'undefined'
        ) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'nitreck-upsells',
            productVariantId: variantId,
            cartData: data
          });
        }

        requestAnimationFrame(() => {
          const status = document.getElementById('CartDrawer-LiveRegionText');
          if (status) {
            status.textContent =
              `${productTitle} wurde zum Warenkorb hinzugefügt.`;
          }
        });
      } catch (error) {
        requireReload = confirmedAdded || !explicitRejection;
        errorBox.textContent = confirmedAdded
          ? 'Der Artikel wurde hinzugefügt. Bitte aktualisiere den Warenkorb, damit der aktuelle Stand angezeigt wird.'
          : requireReload
            ? 'Bitte aktualisiere zuerst den Warenkorb, um den aktuellen Stand zu prüfen, bevor du erneut hinzufügst.'
            : error.message;
        errorBox.hidden = false;
        if (requireReload) button.dataset.ntReload = 'true';
      } finally {
        window.clearTimeout(timeout);
        controls.forEach(el => {
          el.disabled = false;
        });
        button.textContent = requireReload
          ? 'Warenkorb aktualisieren'
          : oldLabel;
        this.busy = false;
        this.removeAttribute('aria-busy');
      }
    }
  }

  if (!customElements.get('nt-delivery-window')) {
    customElements.define('nt-delivery-window', NitreckDeliveryWindow);
  }
  if (!customElements.get('nt-cart-upsells')) {
    customElements.define('nt-cart-upsells', NitreckCartUpsells);
  }
})();